import FloatBtn from './float-btn.vue'
export default FloatBtn
